import { useEffect, useRef, useState } from "react";

/**
 * Reveal-on-scroll helper using IntersectionObserver.
 * Returns [ref, isVisible]. Once seen, stays visible.
 */
export function useReveal({ threshold = 0.12, rootMargin = "0px 0px -80px 0px" } = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            setVisible(true);
            obs.unobserve(e.target);
          }
        }
      },
      { threshold, rootMargin },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);
  return [ref, visible];
}
